import designTokens from '@customink/design-tokens/build/ci_light/js/designTokens';
import {Box, Typography} from '@customink/pigment-react';
import {styled} from '@customink/pigment-react/lib/themeCustomink';
import PropTypes from 'prop-types';
import React from 'react';

const Text = styled(Typography)({
  fontSize: '13px',
  lineHeight: '16px'
});

export default function Badge({title}) {
  return (
    <Box
      data-testid="product-header-badge"
      sx={{
        alignItems: 'center',
        backgroundColor: designTokens.color.red.default.value,
        borderRadius: '0.5rem 0 0.5rem 0',
        display: 'flex',
        gap: '0.625rem',
        justifyContent: 'center',
        padding: '0.25rem 0.5rem',
        whiteSpace: 'nowrap'
      }}>
      <Text color="white" fontWeight={700}>
        {title}
      </Text>
    </Box>
  );
}

Badge.propTypes = {
  title: PropTypes.string.isRequired
};
